module.exports = __webpack_public_path__ + "img/male.70b3be67.svg";